package com.yogaaicoach.pages.shared.media

import com.yogaaicoach.common.network.ApiClient

import io.ktor.http.*
import io.ktor.utils.io.*
import kotlinx.serialization.Serializable

@Serializable
data class MediaResponse(
    val url: String
)

class MediaApi(private val client: ApiClient) {
    suspend fun getVideo2(videoUrl: String): ByteReadChannel? {
        return client.makeRequest(
            url = "${Config.API_URL}/video?name=$videoUrl",
            method = HttpMethod.Get
        )
//        Maybe add this contentType
//        val response: HttpResponse = client.client.get("${Config.API_URL}/video?name=$videoUrl") {
//            accept(ContentType.Video.MP4)
//        }
    }

    suspend fun getAudio(audioName: String): ByteReadChannel? {
        return client.makeRequest(
            url = "${Config.API_URL}/audio?name=$audioName",
            method = HttpMethod.Get
        )
    }

    suspend fun getVideoUrl(videoName: String): MediaResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/videoUrl?name=$videoName",
            method = HttpMethod.Get
        )
    }

    suspend fun getAudioUrl(audioName: String): MediaResponse? {
        return client.makeRequest(
            url = "${Config.API_URL}/audioUrl?name=$audioName",
            method = HttpMethod.Get
        )
    }

}